import { render, staticRenderFns } from "./NewContentTwo.vue?vue&type=template&id=3604df2a&"
import script from "./NewContentTwo.vue?vue&type=script&lang=js&"
export * from "./NewContentTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3604df2a')) {
      api.createRecord('3604df2a', component.options)
    } else {
      api.reload('3604df2a', component.options)
    }
    module.hot.accept("./NewContentTwo.vue?vue&type=template&id=3604df2a&", function () {
      api.rerender('3604df2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/contents/NewContentTwo.vue"
export default component.exports